import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Mail, Phone, Edit2 } from 'lucide-react';

export default function AgentCard({ agent, consultantCount, consultants, onEdit }) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-start justify-between space-y-0 pb-2">
        <div>
          <CardTitle className="text-lg font-semibold">{agent.name}</CardTitle>
          <div className="flex items-center gap-2 mt-2 text-sm text-muted-foreground">
            {agent.email && (
              <span className="flex items-center gap-1"><Mail className="h-4 w-4" />{agent.email}</span>
            )}
            {agent.phone && (
              <span className="flex items-center gap-1"><Phone className="h-4 w-4" />{agent.phone}</span>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant={agent.is_active ? 'default' : 'secondary'}>
            {agent.is_active ? 'Active' : 'Inactive'}
          </Badge>
          <Button variant="ghost" size="icon" onClick={() => onEdit(agent)} aria-label="Edit agent">
            <Edit2 className="h-4 w-4" />
          </Button>
        </div>
      </CardHeader>
      <CardContent className="space-y-2">
        <p className="text-sm text-muted-foreground">
          Assigned consultants: <strong>{consultantCount}</strong>
        </p>
        <div className="flex flex-wrap gap-2">
          {consultants.map((consultant) => (
            <Badge key={consultant.id} variant="outline">
              {consultant.name}
            </Badge>
          ))}
          {consultants.length === 0 && (
            <span className="text-sm text-muted-foreground">No consultants assigned</span>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
